import { NgModule } from '@angular/core';
import { Co2Module } from '@cfp/ui/pipes';
import {
  BuildingEnergyConsumptionService,
  BuildingMeasuresListService,
  BuildingsService,
  RoadmapService
} from 'csr-asset-app';
import { RoadmapRoutingModule } from './roadmap-routing';

@NgModule({
  imports: [Co2Module],
  providers: [RoadmapService, BuildingsService, BuildingMeasuresListService, BuildingEnergyConsumptionService]
})
export class RoadmapModule {}

@NgModule({
  imports: [RoadmapRoutingModule, RoadmapModule]
})
export class RoadmapModuleWithRouting {}
